import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Tooltip } from "reactstrap";
import styled from "styled-components";
import { sleep } from "src/shared/async/sleep";
import { useTooltip } from "src/shared/components/useTooltip";

export interface ICopyButtonProps {
  value: string;
}

export const CopyButton = ({ value }: ICopyButtonProps) => {
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);

  const handleCopy = useCallback(
    async (event: React.SyntheticEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      setShowCopiedTooltip(true);

      await navigator.clipboard.writeText(value);

      await sleep(1000);
      setShowCopiedTooltip(false);
    },
    [value],
  );

  const { containerRef, target } = useTooltip();

  return (
    <>
      <CopyIcon
        href=""
        onClick={handleCopy}
        className="ml-1"
        ref={containerRef}
      >
        <FontAwesomeIcon icon={faCopy} />
      </CopyIcon>
      {target && (
        <Tooltip isOpen={showCopiedTooltip} placement="top" target={target}>
          {showCopiedTooltip ? <FormattedMessage id="ui.copied" /> : null}
        </Tooltip>
      )}
    </>
  );
};

const CopyIcon = styled.a(() => ({
  flexGrow: 0,
  flexShrink: 0,
}));
